import { render, staticRenderFns } from "./ChangeTime.vue?vue&type=template&id=96a92b66&scoped=true&"
import script from "./ChangeTime.vue?vue&type=script&lang=js&"
export * from "./ChangeTime.vue?vue&type=script&lang=js&"
import style0 from "./ChangeTime.vue?vue&type=style&index=0&id=96a92b66&prod&lang=css&"
import style1 from "./ChangeTime.vue?vue&type=style&index=1&id=96a92b66&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a92b66",
  null
  
)

export default component.exports